module.exports = __webpack_public_path__ + "img/side-web.16632061.png";